<template>
  <div data-div="visoes-financeiras" style="margin-bottom: 15px">
    <nav-menu class="impressao"></nav-menu>

    <div id="visao-financeira" class="w3-row w3-container">
      <div class="w3-block w3-text-theme w3-margin-top">
        <h3 class="impressao">
          <i class="fas fa-dollar-sign impressao"></i> Visões Financeiras
        </h3>
      </div>
    </div>

    <div 
      data-div="configuracoes"
      class="w3-container"
      v-if="!processando"
    >
      <button class="w3-theme w3-button impressao" @click="abrirModalConfiguracoes">
        <i class="fas fa-cog"></i> Configurações
      </button>

      <button
        v-if="!processando"
        class="w3-button w3-theme impressao" 
        @click="processar()"
      >
        <i class="fa fa-play-circle"></i> Processar
      </button>

      <button
        data-button="gravar"
        class="w3-button w3-theme impressao"
        @click="gravarRelatorio()"
        v-if="funcionarios && !processando">
          <i class="far fa-save"></i> Gravar
      </button>
      
      <button 
        data-button="imprimir"
        class="w3-button w3-blue impressao"
        @click="imprimir()"
        v-if="funcionarios && !processando">
          <i class="fas fa-print"></i> Imprimir
      </button>
    </div>

    <div class="w3-container w3-col s12 " v-if="processando">
      <div class="w3-theme w3-card-2 w3-panel w3-padding w3-col s12 m3 l2">
        <i class="fa fa-sync-alt w3-spin "></i> Processando...
      </div>
    </div>
    
    <div class="apresentacao w3-display-topright">
      <img alt="" src="static/imagens/logos/logo_santri.png" 
        style="width: 4rem;" 
        class="w3-margin-bottom"
      >
    </div>
    
    <p style="font-size: 30px;"><i class="fas fa-dollar-sign"></i> Visões Financeiras</p>
    
    <div class="w3-container" v-if="funcionarios">
      <h4>1. Considerações preliminares</h4>
      <textarea 
        class="w3-block w3-border"
        v-model="textos.memo_texto_consideracao_preliminar" 
        cols="60" 
        rows="4" 
        maxlength="500">
      </textarea>
      <p>{{textos.memo_texto_consideracao_preliminar}}</p>

      <h4>2. Financeiro</h4>
      <textarea 
        class="w3-block w3-border"
        v-model="textos.memo_texto_financeiro" 
        cols="60" 
        rows="4" 
        maxlength="500" 
        wrap="hard">
      </textarea>
      <p>{{textos.memo_texto_financeiro}}</p>
    </div>

    <div v-if="tem_funcionario_desconto_venda">
      <div class="w3-container">
        <h5><i class="fa fa-check"></i> Desconto na venda</h5>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_texto_desconto_venda"
          cols="60"
          rows="4" 
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_desconto_venda}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
              <th style="text-align: right">Desc. máx. venda</th>
              <th style="text-align: right">Desc. máx. F5</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaDescontoVenda' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeDarDescontoVenda(funcionario.percentual_desconto_maximo, funcionario.percentual_desconto_maximo_f5)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">
                {{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}
              </td>
              <td style="text-align: left">
                {{funcionario.nome_cargo}}
              </td>
              <td style="text-align: right">
                {{nPadraoPercentual(funcionario.percentual_desconto_maximo, 2)}}
              </td>
              <td style="text-align: right">
                {{nPadraoPercentual(funcionario.percentual_desconto_maximo_f5, 2)}}
              </td>
            </tr>
          </tbody>
        </table>

        <strong>Parecer da Santri</strong>
        <textarea 
          class="w3-block w3-border" 
          v-model="textos.memo_parecer_santri_desconto_venda"
          cols="60"
          rows="4" 
          maxlength="500" 
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_santri_desconto_venda}}</p>

      </div>
    </div>


    <div v-if="tem_funcinario_desconto_promocao">
      <div class="w3-container">
        <h5><i class="fa fa-check"></i> Descontos máximos em promoções/ponta de estoque</h5>
        <textarea 
          class="w3-block w3-border" 
          v-model="textos.memo_texto_desconto_promocoes" 
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_desconto_promocoes}}</p>

        <table class="tabela-resultado">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
              <th style="text-align: right">Desc. máx. promo.</th>
              <th style="text-align: right">Desc. máx. ponta est.</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaDescontoPromocao' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeDarDescontoPromocaoPontaEstoque(funcionario.percentual_desc_max_promocao, funcionario.percentual_desc_max_ponta_est)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">
                {{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}
              </td>
              <td style="text-align: left">
                {{funcionario.nome_cargo}}
              </td>
              <td style="text-align: right">
                {{nPadraoPercentual(funcionario.percentual_desc_max_promocao, 2)}}
              </td>
              <td style="text-align: right">
                {{nPadraoPercentual(funcionario.percentual_desc_max_ponta_est, 2)}}
              </td>
            </tr>
          </tbody>
        </table>

        <br>

        <strong>Parecer da Santri</strong>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_parecer_santri_desconto_promocao"
          cols="60" 
          rows="4" 
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_santri_desconto_promocao}}</p>
      </div>
    </div>

    <!-- sempre visível para não dar problemas na pintura (canvas) na função criarGrafico -->
    <div class="w3-container" v-show="juros_vendas_por_periodo">
      <h5><i class="fa fa-check"></i> Juros/descontos cobrados na venda - Resumo por períodos</h5>

      <div class="w3-col l2 m4 s12">
        <table class="tabela-resultado-menor w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Período</th>
              <th style="text-align: right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="periodo in juros_vendas_por_periodo"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{periodo.descricao}}</td>
              <td style="text-align: right">{{nPadrao(periodo.resultado, 2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="container_grafico_juros_vendas_por_periodo" class="w3-col l9 m7 s12 w3-right">
        <canvas id="pintura_grafico_juros_vendas_por_periodo"></canvas>
      </div>
    </div>

    <div v-if="tem_funcionario_desconto_financeiro">
      <div class="w3-container">
        <h5><i class="fa fa-check"></i> Descontos financeiros</h5>
        <textarea
          class="w3-block w3-border"
          v-model="textos.memo_texto_desconto_financeiro" 
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_desconto_financeiro}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
              <th style="text-align: right">Percentual máximo</th>
              <th style="text-align: right">Valor máximo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaDescontoFinanceiro' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeDarDescontoFinanceiro(funcionario.percentual_desconto_maximo_fin, funcionario.valor_desconto_maximo_fin)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
              <td style="text-align: right">{{nPadraoPercentual(funcionario.percentual_desconto_maximo_fin, 2)}}</td>
              <td style="text-align: right">{{nPadrao(funcionario.valor_desconto_maximo_fin, 2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- sempre visível para não dar problemas na pintura (canvas) na função criarGrafico -->
    <div class="w3-container" v-show="tem_funcionario_desconto_financeiro">
      <h5><i class="fa fa-check"></i> Descontos financeiros concedidos - Resumo por períodos</h5>

      <div class="w3-col l2 m4 s12" v-if="descontos_man_financ_por_periodo">
        <table class="tabela-resultado-menor w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Período</th>
              <th style="text-align: right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaPeriodoDescontoFinanceiro' + apenasNumeros(periodo.data_1)"
              v-for="periodo in descontos_man_financ_por_periodo"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{periodo.descricao}}</td>
              <td style="text-align: right">{{nPadrao(periodo.resultado, 2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="container_grafico_descontos_concedidos_periodo" class="w3-col l9 m7 s12 w3-right">
        <canvas id="pintura_grafico_descontos_concedidos_periodo"></canvas>
      </div>
    </div>


    <div v-if="tem_funcionario_gerar_juros">
      <div class="w3-container">
        <h5><i class="fa fa-check"></i> Usuários que podem zerar juros</h5>
        <textarea 
          class="w3-block w3-border" 
          v-model="textos.memo_texto_juros" 
          cols="60" 
          rows="4"
          maxlength="500" 
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_juros}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
              <th style="text-align: center">Zerar</th>
              <th style="text-align: right">% min.fin.</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaZerarJuros' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeZerarJuros(funcionario.permitir_zerar_juros_fin, funcionario.percentual_juros_minimo_fin)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">
                {{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}
              </td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
              <td style="text-align: center">{{simNao(funcionario.permitir_zerar_juros_fin)}}</td>
              <td style="text-align: right">
                {{nPadraoPercentual(funcionario.percentual_juros_minimo_fin, 2)}}
              </td>
            </tr>
          </tbody>
        </table>
        
        <strong>Parecer da Santri</strong>
        <textarea
          class="w3-block w3-border"
          v-model="textos.memo_parecer_santri_juros"
          cols="60"
          rows="4" 
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_santri_juros}}</p>
      </div>
    </div>

    <div v-if="tem_funcionario_trocar_data_vencimento_fin">
      <div class="w3-container">
        <h5><i class="fa fa-check"></i> Trocar datas de financeiros</h5>

        <strong class="w3-margin-top">Trocar datas de contas a receber</strong>
        <textarea 
          class="w3-block w3-border" 
          v-model="textos.memo_texto_trocar_data_contas_receber"
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_trocar_data_contas_receber}}</p>
        <br>
        <strong class="w3-margin-top">Trocar datas de contas a pagar</strong>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_texto_trocar_data_contas_pagar"
          cols="60"
          rows="4" 
          maxlength="500" 
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_trocar_data_contas_pagar}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
              <th style="text-align: right">Trocar data ct. receber (dias)</th>
              <th style="text-align: right">Trocar data ct. a pagar (dias)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaFuncionarioTrocaDatas' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeTrocarDataVencimentoFin(funcionario.max_dias_troca_vencto_cta_rec, funcionario.max_dias_troca_vencto_cta_pag)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">
                {{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}
              </td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
              <td style="text-align: right">{{nPadrao(funcionario.max_dias_troca_vencto_cta_rec, 0)}}</td>
              <td style="text-align: right">
                {{nPadrao(funcionario.max_dias_troca_vencto_cta_pag, 0)}}
              </td>
            </tr>
          </tbody>
        </table>

        <strong>Parecer da Santri</strong>
        <textarea
          class="w3-block w3-border"
          v-model="textos.memo_parecer_trocar_data_contas" 
          cols="60" 
          rows="4" 
          maxlength="500" 
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_trocar_data_contas}}</p>
      </div>
    </div>

    <div v-if="tem_funcionario_lancamento_manual_caixas_bancos">
      <div class="w3-container">
        <h5><i class="fa fa-check"></i> Lançamentos manuais de caixas e bancos</h5>
        <textarea
          class="w3-block w3-border"
          v-model="textos.memo_texto_lancamentos_manuais_cx_bancos"
          cols="60" 
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_trocar_data_contas}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaLancManCxBancos' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeFazerLancamentoManualCaixasBancos(funcionario.lancamentos_manuais_caixas_bancos)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
            </tr>
          </tbody>
        </table>

        <strong>Parecer da Santri</strong>
        <textarea 
          class="w3-block w3-border" 
          v-model="textos.memo_parecer_lancamentos_manuais_cx_bancos" 
          cols="60" 
          rows="4"
          maxlength="500" 
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_lancamentos_manuais_cx_bancos}}</p>

      </div>
    </div>

    <!-- sempre visível para não dar problemas na pintura (canvas) na função criarGrafico -->
    <div class="w3-container" v-show="creditos_manuais_gerados_por_periodo">
      <h6>Quantidades de créditos manuais gerados</h6>

      <div class="w3-col l2 m4 s12">
        <table class="tabela-resultado-menor w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Período</th>
              <th style="text-align: right">Quantidade</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="periodo in creditos_manuais_gerados_por_periodo"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{periodo.descricao}}</td>
              <td style="text-align: right">{{nPadrao(periodo.quantidade, 0)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="container_grafico_creditos_gerados_quantidade" class="w3-col l9 m7 s12 w3-right">
        <canvas id="pintura_grafico_creditos_gerados_quantidade"></canvas>
      </div>
    </div>

    <!-- sempre visível para não dar problemas na pintura (canvas) na função criarGrafico -->
    <div class="w3-container" v-show="tem_movimento_credito_manual_entrada">
      <h6 v-if="creditos_manuais_gerados_por_periodo">Totais (R$) - Créditos manuais gerados / Entradas</h6>

      <div class="w3-col l2 m4 s12">
        <table class="tabela-resultado-menor w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Período</th>
              <th style="text-align: right">Entradas</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="periodo in creditos_manuais_gerados_por_periodo"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{periodo.descricao}}</td>
              <td style="text-align: right">{{nPadrao(periodo.entradas, 2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="container_grafico_creditos_gerados_entradas" class="w3-col l9 m7 s12 w3-right">
        <canvas id="pintura_grafico_creditos_gerados_entradas"></canvas>
      </div>
    </div>

    <!-- sempre visível para não dar problemas na pintura (canvas) na função criarGrafico -->
    <div class="w3-container" v-show="creditos_manuais_gerados_por_periodo">
      <h6>Totais (R$) - Créditos manuais gerados / Saídas</h6>

      <div class="w3-col l2 m4 s12" >
        <table class="tabela-resultado-menor w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Período</th>
              <th style="text-align: right">Saídas</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="periodo in creditos_manuais_gerados_por_periodo"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{periodo.descricao}}</td>
              <td style="text-align: right">{{nPadrao(periodo.saidas, 2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="container_grafico_creditos_gerados_saidas" class="w3-col l9 m7 s12 w3-right">
        <canvas id="pintura_grafico_creditos_gerados_saidas"></canvas>
      </div>
    </div>

    <!-- sempre visível para não dar problemas na pintura (canvas) na função criarGrafico -->
    <div class="w3-container" v-show="tem_movimento_credito_manual_entrada">
      <h6 v-if="creditos_manuais_gerados_por_periodo">Totais (R$) - Créditos manuais gerados (diferença) / entradas - saídas</h6>

      <div class="w3-col l2 m4 s12" v-if="creditos_manuais_gerados_por_periodo">
        <table class="tabela-resultado-menor w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Período</th>
              <th style="text-align: right">Diferença</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="periodo in creditos_manuais_gerados_por_periodo"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{periodo.descricao}}</td>
              <td style="text-align: right">{{nPadrao(periodo.diferenca, 2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="container_grafico_creditos_gerados_diferenca" class="w3-col l9 m7 s12 w3-right">
        <canvas id="pintura_grafico_creditos_gerados_diferenca"></canvas>
      </div>
    </div>

    <div v-show="tem_funcionario_lancamento_credito_contas_pagar" class="w3-container">
      <strong>Lançamentos manuais gerados</strong>
      <textarea
        class="w3-block w3-border"
        v-model="textos.memo_texto_introducao_lancamentos_manuais_gerados" 
        cols="60" 
        rows="4" 
        maxlength="500" 
        wrap="hard">
      </textarea>
      <p>{{textos.memo_texto_introducao_lancamentos_manuais_gerados}}</p>

      <div class="w3-col">
        <h6><i class="fa fa-check"></i> Lançamentos de créditos pela tela de contas a pagar</h6>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_texto_lancamentos_manuais_cr_pagar"
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_lancamentos_manuais_cr_pagar}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaCredPagar' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeGerarCreditoContasPagar(funcionario.creditos_manuais_pagar)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div v-if="tem_funcionario_gerente">
      <div class="w3-container">
        <h6><i class="fa fa-check"></i> Usuários gerentes de sistema</h6>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_texto_gerente_sistema"
          cols="60" 
          rows="4" 
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_gerente_sistema}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaFuncGerente' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="eGerente(funcionario.gerente)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
            </tr>
          </tbody>
        </table>

        <strong>Parecer da Santri</strong>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_parecer_gerente_sistema"
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_parecer_gerente_sistema}}</p>
      </div>
    </div>

    <div  v-if="tem_funciorario_correcao_estoque">
      <div class="w3-container">
        <h6><i class="fa fa-check"></i> Usuários com acesso a correção normal de estoque</h6>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_texto_correcao_estoque"
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_correcao_estoque}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeCorrecaoNormalEstoque(funcionario.correcoes_normais_estoque)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
            </tr>
          </tbody>
        </table>

        <div class="w3-col">
          <h6><i class="fa fa-check"></i> Valores de correções normais de estoque - Sistema</h6>
          <div class="w3-col w3-white" v-if="correcoes_estoque_por_periodo">
            <table class="tabela-resultado w3-margin-top ">
              <thead>
                <tr class="borda-pontilhada-base">
                  <th style="text-align: left">Periodo</th>
                  <th style="text-align: left">Código</th>
                  <th style="text-align: left">Empresa</th>
                  <th style="text-align: left">Movimentações</th>
                  <th style="text-align: left">Valor entrada</th>
                  <th style="text-align: left">Valor saida</th>
                  <th style="text-align: left">Valor saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="empresa in correcoes_estoque_por_periodo"
                  class="borda-pontilhada-base"
                >
                  <td style="text-align: left">{{empresa.descricao}}</td>
                  <td style="text-align: left">{{empresa.empresa_id}}</td>
                  <td style="text-align: left">{{empresa.nome_resumido_empresa}}</td>
                  <td style="text-align: left">{{empresa.qtd_movimentos}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_entrada, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_saida, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.saldo, 2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
      
          <div id="container_grafico_correcoes_estoque_por_periodo" class="w3-white w3-margin-top w3-col">
            <canvas id="pintura_grafico_correcoes_estoque_por_periodo"></canvas>
          </div>
        
          <div class="w3-col w3-white">
            <strong>Parecer da Santri</strong>
            <textarea
              class="w3-block w3-border" 
              v-model="textos.memo_parecer_correcao_estoque_sistema" 
              cols="60"
              rows="4"
              maxlength="500"
              wrap="hard">
            </textarea>
            <p>{{textos.memo_parecer_correcao_estoque_sistema}}</p>
          </div>
        </div>
        
        <div class="w3-col">
          <h6><i class="fa fa-check"></i> Valores de correções normais de estoque - Sem emissão de notas</h6>
          <div class="w3-col w3-white" v-if="correcoes_estoque_sem_emissao_nota_por_periodo">
            <table class="tabela-resultado w3-margin-top ">
              <thead>
                <tr class="borda-pontilhada-base">
                  <th style="text-align: left">Periodo</th>
                  <th style="text-align: left">Código</th>
                  <th style="text-align: left">Empresa</th>
                  <th style="text-align: left">Movimentações</th>
                  <th style="text-align: left">Valor entrada</th>
                  <th style="text-align: left">Valor saida</th>
                  <th style="text-align: left">Valor saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="empresa in correcoes_estoque_sem_emissao_nota_por_periodo"
                  class="borda-pontilhada-base"
                >
                  <td style="text-align: left">{{empresa.descricao}}</td>
                  <td style="text-align: left">{{empresa.empresa_id}}</td>
                  <td style="text-align: left">{{empresa.nome_resumido_empresa}}</td>
                  <td style="text-align: left">{{empresa.qtd_movimentos}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_entrada, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_saida, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.saldo, 2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div id="container_grafico_correcoes_estoque_sem_emissao_nota_por_periodo" class="w3-col w3-white w3-margin-top">
            <canvas id="pintura_grafico_correcoes_estoque_sem_emissao_nota_por_periodo"></canvas>
          </div>
          
          <strong>Parecer da Santri</strong>
          <textarea 
            class="w3-block w3-border" 
            v-model="textos.memo_parecer_correcao_estoque_sem_notas" 
            cols="60"
            rows="4" 
            maxlength="500"
            wrap="hard">
          </textarea>
          <p>{{textos.memo_parecer_correcao_estoque_sem_notas}}</p>
        </div>
      </div>
    </div>

    <div v-show="tem_funcionario_saida_uso_consumo">
      <div class="w3-container">
        <h6><i class="fa fa-check"></i> Usuários autorizados a gerar saídas para uso e consumo</h6>
        <textarea
          class="w3-block w3-border"
          v-model="textos.memo_texto_saida_uso_consumo" 
          cols="60"
          rows="4"
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_saida_uso_consumo}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaFuncUsoConsumo' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeGerarSaidaUsoConsumo(funcionario.saidas_uso_consumo)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
            </tr>
          </tbody>
        </table>
        
        <div class="w3-col">
          <h6><i class="fa fa-check"></i> Valor de movimentações de saídas para uso e consumo</h6>
          <div class="w3-col w3-white" v-if="correcoes_estoque_uso_consumo_por_periodo">
            <textarea
              class="w3-block w3-border"
              v-model="textos.memo_texto_saida_uso_consumo" 
              cols="60"
              rows="4"
              maxlength="500"
              wrap="hard">
            </textarea>
            <p>{{textos.memo_texto_saida_uso_consumo}}</p>
            <table class="tabela-resultado w3-margin-top ">
              <thead>
                <tr class="borda-pontilhada-base">
                  <th style="text-align: left">Periodo</th>
                  <th style="text-align: left">Código</th>
                  <th style="text-align: left">Empresa</th>
                  <th style="text-align: left">Movimentações</th>
                  <th style="text-align: left">Valor entrada</th>
                  <th style="text-align: left">Valor saida</th>
                  <th style="text-align: left">Valor saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="empresa in correcoes_estoque_uso_consumo_por_periodo"
                  class="borda-pontilhada-base"
                >
                  <td style="text-align: left">{{empresa.descricao}}</td>
                  <td style="text-align: left">{{empresa.empresa_id}}</td>
                  <td style="text-align: left">{{empresa.nome_resumido_empresa}}</td>
                  <td style="text-align: left">{{empresa.qtd_movimentos}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_entrada, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_saida, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.saldo, 2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div id="container_grafico_correcoes_estoque_uso_consumo_por_periodo" class="w3-col w3-margin-top">
            <canvas id="pintura_grafico_correcoes_estoque_uso_consumo_por_periodo"></canvas>
          </div>
  
        <strong>Parecer da Santri</strong>
          <textarea 
            class="w3-block w3-border" 
            v-model="textos.memo_parecer_saida_uso_consumo" 
            cols="60"
            rows="4" 
            maxlength="500"
            wrap="hard">
          </textarea>
          <p>{{textos.memo_parecer_saida_uso_consumo}}</p>
        </div>
      </div>
    </div>

    <div v-if="tem_funcionario_saida_bonificacao">
      <div class="w3-container">
        <h6><i class="fa fa-check"></i> Usuários autorizados a gerar saídas de bonificações</h6>
        <textarea 
          class="w3-block w3-border"
          v-model="textos.memo_texto_saida_bonificacao" 
          cols="60"
          rows="4" 
          maxlength="500"
          wrap="hard">
        </textarea>
        <p>{{textos.memo_texto_saida_bonificacao}}</p>

        <table class="tabela-resultado w3-margin-top">
          <thead>
            <tr class="borda-pontilhada-base">
              <th style="text-align: left">Funcionário</th>
              <th style="text-align: left">Cargo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="'linhaFuncBonificacoes' + funcionario.funcionario_id"
              v-for="funcionario in funcionarios"
              v-show="funcionarioPodeGerarSaidaBonificacoes(funcionario.saidas_bonificacoes)"
              class="borda-pontilhada-base"
            >
              <td style="text-align: left">{{nPadrao(funcionario.funcionario_id, 0)}} - {{funcionario.nome_funcionario}}</td>
              <td style="text-align: left">{{funcionario.nome_cargo}}</td>
            </tr>
          </tbody>
        </table>

        <div class="w3-col">
          <h6><i class="fa fa-check"></i> Valor de movimentações de saídas de bonificações E brindes</h6>
          <div class="w3-col w3-white" v-if="correcoes_estoque_bonificacao_brinde_por_periodo">
            <textarea
              class="w3-block w3-border"
              v-model="textos.memo_texto_saida_uso_consumo" 
              cols="60"
              rows="4"
              maxlength="500"
              wrap="hard">
            </textarea>
            <p>{{textos.memo_texto_saida_uso_consumo}}</p>
            <table class="tabela-resultado w3-margin-top ">
              <thead>
                <tr class="borda-pontilhada-base">
                  <th style="text-align: left">Periodo</th>
                  <th style="text-align: left">Código</th>
                  <th style="text-align: left">Empresa</th>
                  <th style="text-align: left">Movimentações</th>
                  <th style="text-align: left">Valor entrada</th>
                  <th style="text-align: left">Valor saida</th>
                  <th style="text-align: left">Valor saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="empresa in correcoes_estoque_bonificacao_brinde_por_periodo"
                  class="borda-pontilhada-base"
                >
                  <td style="text-align: left">{{empresa.descricao}}</td>
                  <td style="text-align: left">{{empresa.empresa_id}}</td>
                  <td style="text-align: left">{{empresa.nome_resumido_empresa}}</td>
                  <td style="text-align: left">{{empresa.qtd_movimentos}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_entrada, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.valor_saida, 2)}}</td>
                  <td style="text-align: left">{{nPadrao(empresa.saldo, 2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        
          <div id="container_grafico_correcoes_estoque_bonificacao_brinde_por_periodo" class="w3-col w3-margin-top">
            <canvas id="pintura_grafico_correcoes_estoque_bonificacao_brinde_por_periodo"></canvas>
          </div>
    
          <strong>Parecer da Santri</strong>
          <textarea 
            class="w3-block w3-border" 
            v-model="textos.memo_parecer_saida_bonificacao" 
            cols="60"
            rows="4" 
            maxlength="500"
            wrap="hard">
          </textarea>
          <p>{{textos.memo_parecer_saida_bonificacao}}</p>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIGURAÇÕES -->
    <div id="modalConfiguracoes" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações
          </h4>
          <span @click="fecharConfiguracoes()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <!-- PÁGINA DE BOTÕES DE CONTROLE DE PÁGINAS -->
        <div class="controlePaginas">
          <button class="tablinks" @click="abrirPaginaConfiguracao('pgConfPrincipal')">Principal</button>
          <button class="tablinks" @click="abrirPaginaConfiguracao('pgConfPeriodos')">Períodos de análise</button>
        </div>

        <!-- PÁGINA PRINCIPAL -->
        <div id="pgConfPrincipal" class="pagina" style="display: block">
          <div class="w3-row w3-container">
            <button 
              class="w3-theme w3-button"
              v-if="!todas_opcoes_marcadas"
              @click="ajustarTodasOpcoes(true)">
              <i class="fas fa-check"></i> Marcar todos
            </button>
            <button
              class="w3-theme w3-button" 
              v-if="todas_opcoes_marcadas" 
              @click="ajustarTodasOpcoes(false)">
              <i class="far fa-times-circle"></i> Desmarcar todos
            </button>
          </div>

          <div class="w3-row w3-container">
            <div class="w3-col s12 m12 l6" :key="opcao.checkbox" v-for="opcao in opcoes">
              <input 
                :id="opcao.id" 
                class="w3-check" 
                v-model="opcao.marcado"
                type="checkbox"/> 
              <label :for="opcao.id">{{opcao.descricao}}</label>
            </div>
          </div>
        </div>

        <!-- PÁGINA DE PERÍODO DE ANÁLISE -->
        <div id="pgConfPeriodos" class="pagina">

          <div class="w3-container">
            <div class="w3-col m12 l4">
              <label>Descrição do período</label>
              <input 
                type="text" 
                id="descricao_periodo"
                class="w3-input w3-border"
                maxlength="12"
                v-model="descricao_periodo_adicionar"/>
            </div>

            <div class="w3-col s12 m6 l4">
              <label>Data inicial</label>
              <input 
                type="date" 
                id="data_inicial_periodo" 
                class="w3-input w3-border" 
                v-model="data_inicial_adicionar"/>
            </div>

            <div class="w3-col s12 m6 l4">
              <label>Data final</label>
              <input
                type="date" 
                id="data_final_periodo"
                class="w3-input w3-border"
                v-model="data_final_adicionar"/>
            </div>
          </div>

          <div class="w3-container">
            <div class="w3-col s12 m6 l3 w3-margin-top">
              <button 
                class="w3-button w3-theme w3-block" 
                @click="adicionarPeriodo">Adicionar
              </button>
            </div>

            <div class="w3-col s12 m6 l3 w3-margin-top">
              <button 
                class="w3-theme w3-button w3-block"
                @click="ajustarPeriodosPadroes()"> Aplicar ano anterior e atual
              </button>
            </div>
          </div>

          <div class="w3-container w3-margin-top">
            <div class="w3-center">
              <div 
                class="periodo w3-col s12 m5 l5"
                :key="'itemPeriodo' + periodo.indice"
                v-for="periodo in periodos">
                <span 
                  @click="removerPeriodo(periodo.indice)" 
                  class="w3-right botao-fechar">&times;
                </span>
                <strong>{{periodo.descricao}}</strong>
                <br>
                <label>
                  {{dateToStringBR(periodo.data_1)}} a {{dateToStringBR(periodo.data_2)}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="w3-container w3-center w3-margin-top">
          <button class="w3-button w3-theme" @click="gravarConfiguracoes()">
            <i class="fa fa-check"></i> Gravar configurações
          </button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import NavMenu from "@/components/Menu"
import RVisoesFinanceiras from "@/components/Rest/RVisoesFinanceiras.js"
import toastr from "toastr"
import VueCharts from 'vue-chartjs'


export default {
  name: "VisoesFinanceiras",
  components: {
    NavMenu
  },
  data() {
    return {
      todas_opcoes_marcadas: false,
      periodos: [],
      correcoes_empresas: [
        {
          empresa_id: 1,
          nome_resumido: 'NOME EMPRESA TESTE 1'
        },
        {
          empresa_id: 2,
          nome_resumido: 'NOME EMPRESA TESTE 2'
        },
      ],

      descricao_periodo_adicionar: undefined,
      data_inicial_adicionar: undefined,
      data_final_adicionar: undefined,

      processando: false,
      tem_resultado: false,

      textos: {
        /* --------------------------- MEMOS --------------------------- */
        memo_texto_consideracao_preliminar: '',

        memo_texto_financeiro:
          'Há autorizações no sistema que possibilitam ao usuário executar operações do dia a dia, ' +
          'porém quando utilizadas de forma errada podem causar prejuízos financeiros. ' +
          'A seguir, abordaremos alguns pontos relacionados as autorizações no sistema. ',

        memo_texto_desconto_venda:
          'Atualmente a permissão de desconto máximo de venda e o desconto máximo de venda F5 está ' +
          'disponibilizada para alguns grupos de funcionários. A seguir apresentamos uma planilha que contém ' +
          'a relação máxima de cada grupo de cargos que possuem as permissões de desconto na venda e desconto na venda F5.',

        memo_parecer_santri_desconto_venda: '',

        memo_texto_desconto_promocoes:
          'O desconto na promoção/ponta de estoque é usado para cobertura de ofertas dos concorrentes. Utilizando este recurso a loja evita ' +
          'de ter que vender o produto com preço normal e conceder um desconto neste preço para cobrir a oferta do concorrente.',

        memo_texto_desconto_financeiro:
          'Pessoas autorizadas a conceder desconto financeiro podem receber um valor menor que o valor principal do título.',

        memo_parecer_santri_desconto_promocao: '',

        memo_texto_juros:
          'Abaixo a relação de usuários autorizados a cobrança mínima de juros ou até mesmo de zerar a cobrança destes juros.',

        memo_parecer_santri_juros:
          'Da forma que está autorizado por usuário, todos acima podem deixar de cobrar juros do cliente. ' +
          'O normal é que cada um tenha sua alçada para cobrança de juros mínimos e outros podem vir a não cobrar juros. ' +
          'Aconselhamos revisar estas autorizações.',

        memo_texto_trocar_data_contas_receber:
          'Esta autorização permite ao usuário prorrogar o vencimento do título. \n' +
          'Quando habilitamos períodos grandes podemos dar margem para o funcionário fazer o fluxo de caixa pessoal dele ' +
          'com recebíveis da empresa. Ex.: existem casos nos quais um conhecido ou parente do funcionário comprou na loja no curto prazo ' +
          'e a funcionária do financeiro (parente/amiga) prorrogou o título por 01 ano.  \n' +
          'O próximo quadro demonstra as autorizações que cada funcionário possui para alterar a data de vencimento das contas a receber.',

        memo_texto_trocar_data_contas_pagar:
          'Esta autorização permite que seja antecipado ou prorrogado o vencimento de um título a pagar, Ex.: Negociou-se com o ' +
          'fornecedor o pagamento de título em 30 dias e o usuário por ter acesso alterou o vencimento para 10 dias, antecipando o ' +
          'pagamento do fornecedor.',

        memo_parecer_trocar_data_contas: '',

        memo_texto_lancamentos_manuais_cx_bancos:
          'Esta autorização além de permitir a saída de recursos da empresa sem que exista uma contra partida no financeiro, ' +
          'permite também que o usuário resolva de qualquer jeito um problema apenas para fechar saldo de caixas e bancos.',

        memo_parecer_lancamentos_manuais_cx_bancos:
          'Retirar acesso dos funcionários da Santri Contabilidade. ' +
          'Verificar há a necessidade de manter as autorizações dos demais usuários para esta operação.',

        memo_texto_introducao_lancamentos_manuais_gerados: '',

        memo_texto_lancamentos_manuais_cr_pagar:
          'Este tipo de lançamento pode vir a gerar desvio na empresa por vias normais (venda ou financeiro). ' +
          'Abaixo a relação de funcionários que tem este acesso:',

        memo_parecer_lancamentos_manuais_cr_pagar:
          'Retirar acesso dos funcionários da Santri Contabilidade. ' +
          'Verificar há a necessidade de manter as autorizações dos demais usuários para esta operação.',

        memo_texto_gerente_sistema: '',


        memo_parecer_gerente_sistema:
          'Retirar acesso dos usuários da Santri Contabilidade. Demais acessos dentro do esperado.',

        memo_texto_correcao_estoque: '',

        memo_parecer_correcao_estoque_sistema: '',

        memo_parecer_correcao_estoque_sem_notas:
          'O quadro acima demonstra que não foi emitida todas as notas referente as correções realizadas no período, ' +
          'isto faz com que se gere uma diferença entre o estoque fiscal e físico (quantitativo).',

        memo_texto_saida_uso_consumo: '',
        memo_parecer_saida_uso_consumo: '',

        memo_texto_saida_bonificacao: '',
        memo_parecer_saida_bonificacao: ''
      },

      /* --------------------------- FIM MEMOS --------------------------- */
      funcionarios: undefined,

      opcoes: [
        {opcao: 'DAB', id: 'ckAdiantarBaixas', descricao: 'Adiantamento de baixas', marcado: true},
        {opcao: 'AVE', id: 'ckAlteracaoVencimento', descricao: 'Alteração de datas de vencimento', marcado: true},
        {opcao: 'CNE', id: 'ckCorrecoesNormaisEstoque', descricao: 'Correções normais de estoque', marcado: true},
        {opcao: 'CMP', id: 'ckCreditosManuaisPagar', descricao: 'Créditos manuais a pagar', marcado: true},
        {opcao: 'DMF', id: 'ckDescontoMaximoFinanceiro', descricao: 'Descontos financeiros', marcado: true},
        {opcao: 'DVE', id: 'ckDescontosVenda', descricao: 'Descontos na venda', marcado: true},
        {opcao: 'DPR', id: 'ckDescontosPromocoesPontaEstoque', descricao: 'Descontos em promoções/ponta de estoque', marcado: true},
        {opcao: 'GER', id: 'ckGerentesSistema', descricao: 'Gerentes de sistema', marcado: true},
        {opcao: 'LCB', id: 'ckLancamentosManuais', descricao: 'Lançamentos manuais de caixas e bancos', marcado: true},
        {opcao: 'ONT', id: 'ckOutrasNotasEmitidas', descricao: 'Outras notas emitidas', marcado: true},
        {opcao: 'SBO', id: 'ckSaidasBonificadas', descricao: 'Saídas de bonificações', marcado: true},
        {opcao: 'SUC', id: 'ckSaidasUsoConsumo', descricao: 'Saídas para uso e consumo', marcado: true},
        {opcao: 'ZJU', id: 'ckZerarJuros', descricao: 'Zerar juros', marcado: true}
      ],

      juros_vendas_por_periodo: undefined,
      descontos_man_financ_por_periodo: undefined,
      creditos_manuais_gerados_por_periodo: undefined,
      correcoes_estoque_por_periodo: undefined, 
      correcoes_estoque_sem_emissao_nota_por_periodo: undefined,
      correcoes_estoque_uso_consumo_por_periodo: undefined,
      correcoes_estoque_bonificacao_brinde_por_periodo: undefined,

      tem_movimento_credito_manual_entrada: false,
      tem_funcinario_desconto_promocao: false,
      tem_funcionario_desconto_financeiro: false,
      tem_funcionario_gerar_juros: false,
      tem_funcionario_lancamento_credito_contas_pagar: false,
      tem_funcionario_saida_bonificacao: false,
      tem_funcionario_saida_uso_consumo: false,
      tem_funciorario_correcao_estoque: false,
      tem_funcionario_gerente: false,
      tem_funcionario_lancamento_manual_caixas_bancos: false,
      tem_funcionario_trocar_data_vencimento_fin: false,
      tem_funcionario_desconto_venda: false,

  
    }
  },
  methods: {
    configurarApiGraficos() {
      Chart.plugins.register({
        beforeRender: function(chart) {
          if (chart.config.options.showAllTooltips) {
            // create an array of tooltips
            // we can't use the chart tooltip because there is only one tooltip per chart
            chart.pluginTooltips = [];
            chart.config.data.datasets.forEach(function(dataset, i) {
              chart.getDatasetMeta(i).data.forEach(function(sector, j) {
                chart.pluginTooltips.push(
                  new Chart.Tooltip(
                    {
                      _chart: chart.chart,
                      _chartInstance: chart,
                      _data: chart.data,
                      _options: chart.options.tooltips,
                      _active: [sector]
                    },
                    chart
                  )
                );
              });
            });

            // turn off normal tooltips
            chart.options.tooltips.enabled = false;
          }
        },
        afterDraw: function(chart, easing) {
          if (chart.config.options.showAllTooltips) {
            // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
            if (!chart.allTooltipsOnce) {
              if (easing !== 1) return;
              chart.allTooltipsOnce = true;
            }

            // turn on tooltips
            chart.options.tooltips.enabled = true;
            Chart.helpers.each(chart.pluginTooltips, function(tooltip) {
              tooltip.initialize();
              tooltip._options.bodyFontFamily = "'Lato', sans-serif"
              tooltip._options.displayColors = false;
              tooltip._options.bodyFontSize = tooltip._chart.height * 0.04;
              tooltip._options.yPadding = 1;
              tooltip._options.xPadding = 1;
              // tooltip._options.position = 'average';
              // tooltip._options.caretSize = tooltip._options.bodyFontSize * 0.5;
              tooltip._options.cornerRadius = tooltip._options.bodyFontSize * 0.5;
              tooltip.update();
              // we don't actually need this since we are not animating tooltips
              tooltip.pivot();
              tooltip.transition(easing).draw();
            });
            chart.options.tooltips.enabled = false;
          }
        }
      })
    },

    async processar() {
      try {

        this.tem_resultado = false;
        let opcoes_marcadas = [];

        for (let i in this.opcoes) {
          if (this.opcoes[i].marcado) {
            opcoes_marcadas.push(
              this.opcoes[i].opcao
            );
          }
        }

        if (!opcoes_marcadas) {
          toastr.error('Selecione pelo menos uma opção de processamento nas configurações!');
          return;
        }

        let periodos_selecionados = [];
        for (let i = 0; i < this.periodos.length; i++) {
          periodos_selecionados.push({
            descricao: this.periodos[i].descricao,
            data_1: this.dateToStringBR(this.periodos[i].data_1),
            data_2: this.dateToStringBR(this.periodos[i].data_2)
          })
        }

        if ((this.periodos == undefined) || (this.periodos.length == 0)) {
          toastr.error('Selecione pelo menos um período de processamento nas configurações!');
          return;
        }

        let parametros = {
          opcoes: opcoes_marcadas,
          periodos: periodos_selecionados
        }

        this.processando = true;
      
        let retorno = await RVisoesFinanceiras.buscarVisoesFinanceiras(
          this.axios,
          parametros
        );
        
        this.processando = false;
        this.tem_resultado = true;
        
        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        this.funcionarios = JSON.parse(
          JSON.stringify(retorno.dados.funcionarios)
        );
        
        this.juros_vendas_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.juros_vendas_por_periodo)
        );
        
        this.descontos_man_financ_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.descontos_man_financ_por_periodo)
        );
        
        this.creditos_manuais_gerados_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.creditos_manuais_gerados_por_periodo)
        );

        this.correcoes_estoque_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.correcoes_estoque_por_periodo)
        );

        this.correcoes_estoque_sem_emissao_nota_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.correcoes_estoque_sem_emissao_nota_por_periodo)
        );

        this.correcoes_estoque_uso_consumo_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.correcoes_estoque_uso_consumo_por_periodo)
        );

        this.correcoes_estoque_bonificacao_brinde_por_periodo = JSON.parse(
          JSON.stringify(retorno.dados.correcoes_estoque_bonificacao_brinde_por_periodo)
        );
      
        this.tem_funcionario_lancamento_credito_contas_pagar = (
          this.temFuncionarioLancamentoCreditoContasPagar()
        );
        
        this.tem_funcinario_desconto_promocao = (
          this.temFuncionarioDescontoPromocao()
        );

        this.tem_funcionario_desconto_financeiro = (
          this.temFuncionarioDescontoFinanceiro()
        );
        
        this.tem_funcionario_gerar_juros = (
          this.temFuncionarioGerarJuros()
        );
        
        this.tem_funcionario_saida_bonificacao = (
          this.temFuncionarioSaidaBonificacao()
        );
        
        this.tem_funcionario_saida_uso_consumo = (
          this.temFuncionarioSaidaUsoConsumo()
        );
        
        this.tem_funciorario_correcao_estoque = (
          this.temFuncionarioCorrecaoEstoque()
        );
        
        this.tem_funcionario_gerente = (
          this.temFuncionarioGerente()
        );
        
        this.tem_funcionario_lancamento_manual_caixas_bancos = (
          this.temFuncionarioLancamentoManualCaixasBancos()
        );
        
        this.tem_funcionario_trocar_data_vencimento_fin = (
          this.temFuncionarioTrocarDataVencimentoFin()
        );

        this.tem_funcionario_desconto_venda = (
          this.temFuncionarioDescontoVenda()
        );
      
        let periodos_grafico = [];
        let dados_grafico = [];
      
        for (let i in this.juros_vendas_por_periodo) {
          await periodos_grafico.push(this.juros_vendas_por_periodo[i].descricao);
          await dados_grafico.push(this.juros_vendas_por_periodo[i].resultado);
        }
        

        await this.criarGrafico(
          'container_grafico_juros_vendas_por_periodo',
          'pintura_grafico_juros_vendas_por_periodo',
          '',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )
        
        periodos_grafico = []
        dados_grafico = []
        for (let i in this.descontos_man_financ_por_periodo) {
          await periodos_grafico.push(this.descontos_man_financ_por_periodo[i].descricao);
          await dados_grafico.push(this.descontos_man_financ_por_periodo[i].resultado);
        }

        await this.criarGrafico(
          'container_grafico_descontos_concedidos_periodo',
          'pintura_grafico_descontos_concedidos_periodo',
          'Descontos concedidos',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )

        periodos_grafico = [];
        dados_grafico = [];
        for (let i in this.creditos_manuais_gerados_por_periodo) {
          await periodos_grafico.push(this.creditos_manuais_gerados_por_periodo[i].descricao);
          await dados_grafico.push(this.creditos_manuais_gerados_por_periodo[i].quantidade);
        }

        await this.criarGrafico(
          'container_grafico_creditos_gerados_quantidade',
          'pintura_grafico_creditos_gerados_quantidade',
          'Créditos manuais gerados - Quantidade',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          0
        );

        this.tem_movimento_credito_manual_entrada = false;
        periodos_grafico = [];
        dados_grafico = [];

        for (let i in this.creditos_manuais_gerados_por_periodo) {
          await periodos_grafico.push(this.creditos_manuais_gerados_por_periodo[i].descricao);
          await dados_grafico.push(this.creditos_manuais_gerados_por_periodo[i].entradas);

          if (nPadrao(this.creditos_manuais_gerados_por_periodo[i].entradas, 2) != nPadrao(0,2)) {
            this.tem_movimento_credito_manual_entrada = true;
          }
        }

        if (this.tem_movimento_credito_manual_entrada) {
          await this.criarGrafico(
            'container_grafico_creditos_gerados_entradas',
            'pintura_grafico_creditos_gerados_entradas',
            'Créditos manuais gerados - Entradas',
            periodos_grafico,
            dados_grafico,
            'N',
            'N',
            2
          )
        }
        
        periodos_grafico = [];
        dados_grafico = [];
        for (let i in this.creditos_manuais_gerados_por_periodo) {
          await periodos_grafico.push(this.creditos_manuais_gerados_por_periodo[i].descricao);
          await dados_grafico.push(this.creditos_manuais_gerados_por_periodo[i].saidas);
        }

        await this.criarGrafico(
          'container_grafico_creditos_gerados_saidas',
          'pintura_grafico_creditos_gerados_saidas',
          'Créditos manuais gerados - Saídas',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )

        if (this.tem_movimento_credito_manual_entrada) {
          periodos_grafico = [];
          dados_grafico = [];
          for (let i in this.creditos_manuais_gerados_por_periodo) {
            await periodos_grafico.push(this.creditos_manuais_gerados_por_periodo[i].descricao);
            await dados_grafico.push(this.creditos_manuais_gerados_por_periodo[i].diferenca);
          }

          await this.criarGrafico(
            'container_grafico_creditos_gerados_diferenca',
            'pintura_grafico_creditos_gerados_diferenca',
            'Créditos manuais gerados - Diferença',
            periodos_grafico,
            dados_grafico,
            'N',
            'N',
            2
          )
        }

        periodos_grafico = []
        dados_grafico = []
        for (let i in this.correcoes_estoque_por_periodo) {
          await periodos_grafico.push(this.correcoes_estoque_por_periodo[i].descricao + 
          " - " +
          this.correcoes_estoque_por_periodo[i].nome_resumido_empresa);
          await dados_grafico.push(this.correcoes_estoque_por_periodo[i].saldo);
        }

        await this.criarGrafico(
          'container_grafico_correcoes_estoque_por_periodo',
          'pintura_grafico_correcoes_estoque_por_periodo',
          '',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )
        
        periodos_grafico = []
        dados_grafico = []
        for (let i in this.correcoes_estoque_sem_emissao_nota_por_periodo) {
          await periodos_grafico.push(this.correcoes_estoque_sem_emissao_nota_por_periodo[i].descricao + 
          " - " +
          this.correcoes_estoque_sem_emissao_nota_por_periodo[i].nome_resumido_empresa);
          await dados_grafico.push(this.correcoes_estoque_sem_emissao_nota_por_periodo[i].saldo);
        }

        await this.criarGrafico(
          'container_grafico_correcoes_estoque_sem_emissao_nota_por_periodo',
          'pintura_grafico_correcoes_estoque_sem_emissao_nota_por_periodo',
          '',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )
        
        periodos_grafico = []
        dados_grafico = []
        for (let i in this.correcoes_estoque_uso_consumo_por_periodo) {
          await periodos_grafico.push(this.correcoes_estoque_uso_consumo_por_periodo[i].descricao + 
          " - " +
          this.correcoes_estoque_uso_consumo_por_periodo[i].nome_resumido_empresa);
          await dados_grafico.push(this.correcoes_estoque_uso_consumo_por_periodo[i].saldo);
        }

        await this.criarGrafico(
          'container_grafico_correcoes_estoque_uso_consumo_por_periodo',
          'pintura_grafico_correcoes_estoque_uso_consumo_por_periodo',
          '',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )
        
        periodos_grafico = []
        dados_grafico = []
        for (let i in this.correcoes_estoque_bonificacao_brinde_por_periodo) {
          await periodos_grafico.push(this.correcoes_estoque_bonificacao_brinde_por_periodo[i].descricao + 
          " - " +
          this.correcoes_estoque_bonificacao_brinde_por_periodo[i].nome_resumido_empresa);
          await dados_grafico.push(this.correcoes_estoque_bonificacao_brinde_por_periodo[i].saldo);
        }

        await this.criarGrafico(
          'container_grafico_correcoes_estoque_bonificacao_brinde_por_periodo',
          'pintura_grafico_correcoes_estoque_bonificacao_brinde_por_periodo',
          '',
          periodos_grafico,
          dados_grafico,
          'N',
          'N',
          2
        )
    
      } catch (error) {
        this.processando = false;
        this.tem_resultado = false;
        return;
      }

    },

    funcionarioPodeDarDescontoVenda(percentual_desconto_maximo, percentual_desconto_maximo_f5) {
      return nPadrao(percentual_desconto_maximo + percentual_desconto_maximo_f5, 2) != nPadrao(0, 2);
    },

    opcaoEstaMarcada(opcao_verificar) {
      for (let i in this.opcoes) {
        if (this.opcoes[i].opcao == opcao_verificar) {
          return this.opcoes[i].marcado;
        }
      }

      return false
    },

    temFuncionarioDescontoVenda() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('DVE'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if
          (this.funcionarioPodeDarDescontoVenda(
            this.funcionarios[i].percentual_desconto_maximo,
            this.funcionarios[i].percentual_desconto_maximo_f5
          )) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeDarDescontoPromocaoPontaEstoque(percentual_desc_max_promocao, percentual_desc_max_ponta_est) {
      return (nPadrao(percentual_desc_max_promocao, 2) != nPadrao(0, 2)) || (nPadrao(percentual_desc_max_ponta_est, 2) != nPadrao(0, 2));
    },

    temFuncionarioDescontoPromocao() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('DPR'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeDarDescontoPromocaoPontaEstoque(this.funcionarios[i].percentual_desc_max_promocao, this.funcionarios[i].percentual_desc_max_ponta_est)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeDarDescontoFinanceiro(percentual_desconto_maximo_fin, valor_desconto_maximo_fin) {
      return nPadrao(percentual_desconto_maximo_fin + valor_desconto_maximo_fin, 2) != nPadrao(0, 2);
    },

    temFuncionarioDescontoFinanceiro() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('DMF'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeDarDescontoFinanceiro(this.funcionarios[i].percentual_desconto_maximo_fin, this.funcionarios[i].valor_desconto_maximo_fin)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeZerarJuros(permitir_zerar_juros_fin, percentual_juros_minimo_fin) {
      return (permitir_zerar_juros_fin == 'S') || (nPadrao(percentual_juros_minimo_fin, 2) != nPadrao(0, 2));
    },

    temFuncionarioGerarJuros() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('ZJU'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeZerarJuros(this.funcionarios[i].permitir_zerar_juros_fin, this.funcionarios[i].percentual_juros_minimo_fin)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeTrocarDataVencimentoFin(max_dias_troca_vencto_cta_rec, max_dias_troca_vencto_cta_pag) {
      return (nPadrao(max_dias_troca_vencto_cta_rec + max_dias_troca_vencto_cta_pag, 2) != nPadrao(0, 2));
    },

    temFuncionarioTrocarDataVencimentoFin() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('AVE'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeTrocarDataVencimentoFin(this.funcionarios[i].max_dias_troca_vencto_cta_rec, this.funcionarios[i].max_dias_troca_vencto_cta_pag)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeFazerLancamentoManualCaixasBancos(lancamentos_manuais_caixas_bancos) {
      return (lancamentos_manuais_caixas_bancos == 'S');
    },

    temFuncionarioLancamentoManualCaixasBancos() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('LCB'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeTrocarDataVencimentoFin(this.funcionarios[i].lancamentos_manuais_caixas_bancos)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeGerarCreditoContasPagar(creditos_manuais_pagar) {
      return (creditos_manuais_pagar == 'S');
    },

    temFuncionarioLancamentoCreditoContasPagar() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('CMP'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeGerarCreditoContasPagar(this.funcionarios[i].creditos_manuais_pagar)) {
          return true;
        }
      }

      return false;
    },

    eGerente(gerente) {
      return (gerente == 'S');
    },

    temFuncionarioGerente() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('GER'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.eGerente(this.funcionarios[i].gerente)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeCorrecaoNormalEstoque(correcoes_normais_estoque) {
      return (correcoes_normais_estoque == 'S');
    },

    temFuncionarioCorrecaoEstoque() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('CNE'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeCorrecaoNormalEstoque(this.funcionarios[i].correcoes_normais_estoque)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeGerarSaidaUsoConsumo(saidas_uso_consumo) {
      return (saidas_uso_consumo == 'S');
    },

    temFuncionarioSaidaUsoConsumo() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('SUC'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeGerarSaidaUsoConsumo(this.funcionarios[i].saidas_uso_consumo)) {
          return true;
        }
      }

      return false;
    },

    funcionarioPodeGerarSaidaBonificacoes(saidas_bonificacoes) {
      return (saidas_bonificacoes == 'S')
    },

    temFuncionarioSaidaBonificacao() {
      if ((!this.funcionarios) || (this.funcionarios.length == 0) || (!this.opcaoEstaMarcada('SBO'))) {
        return false;
      }

      for (let i = 0; i < this.funcionarios.length; i++) {
        if (this.funcionarioPodeGerarSaidaBonificacoes(this.funcionarios[i].saidas_bonificacoes)) {
          return true;
        }
      }

      return false;
    },

    abrirModalConfiguracoes() {
      $("#modalConfiguracoes").toggle(100);
    },

    fecharConfiguracoes() {
      $("#modalConfiguracoes").removeAttr("style").hide();
    },

    ajustarPeriodosPadroes() {
      let x_data_atual = new Date();

      this.periodos = [];

      /* --------------------- PRIMEIRO TRIMESTRE, ANO ANTERIOR --------------------- */
      let x_data_1 = new Date(x_data_atual.getFullYear() - 1, 0, 1) ;  /* 01/01/2018 */
      let x_data_2 = new Date(x_data_atual.getFullYear() - 1, 2, 31) ; /* 31/03/2018 */
      let x_descricao = '1º trim/' + x_data_1.getFullYear();

      this.periodos.push({
        indice: 1,
        descricao: x_descricao,
        data_1: x_data_1,
        data_2: x_data_2
      })

      /* --------------------- SEGUNDO TRIMESTRE, ANO ANTERIOR --------------------- */
      x_data_1 = new Date(x_data_atual.getFullYear() - 1, 3, 1);   /* 01/04/2018 */
      x_data_2 = new Date(x_data_atual.getFullYear() - 1, 5, 30);  /* 30/06/2018 */
      x_descricao = '2º trim/' + x_data_1.getFullYear()

      this.periodos.push({
        indice: 2,
        descricao: x_descricao,
        data_1: x_data_1,
        data_2: x_data_2
      })

      /* --------------------- TERCEIRO TRIMESTRE, ANO ANTERIOR --------------------- */
      x_data_1 = new Date(x_data_atual.getFullYear() - 1, 6, 1);   /* 01/07/2018 */
      x_data_2 = new Date(x_data_atual.getFullYear() - 1, 8, 30);  /* 30/09/2018 */
      x_descricao = '3º trim/' + x_data_1.getFullYear();

      this.periodos.push({
        indice: 3,
        descricao: x_descricao,
        data_1: x_data_1,
        data_2: x_data_2
      })

      /* --------------------- QUARTO TRIMESTRE, ANO ANTERIOR --------------------- */
      x_data_1 = new Date(x_data_atual.getFullYear() - 1, 9, 1);   /* 01/10/2018 */
      x_data_2 = new Date(x_data_atual.getFullYear() - 1, 11, 31); /* 31/12/2018 */
      x_descricao = '4º trim/' + x_data_1.getFullYear();

      this.periodos.push({
        indice: 4,
        descricao: x_descricao,
        data_1: x_data_1,
        data_2: x_data_2
      })


      /* --------------------- PRIMEIRO TRIMESTRE, ANO ATUAL --------------------- */
      x_data_1 = new Date(x_data_atual.getFullYear(), 0, 1);   /* 01/01/2019 */
      x_data_2 = new Date(x_data_atual.getFullYear(), 2, 31);  /* 31/03/2019 */
      x_descricao = '1º trim/' + x_data_1.getFullYear();

      /* Se o primeiro trimestre já fechou no ano atual */
      if (x_data_atual > x_data_2) {
        this.periodos.push({
          indice: 5,
          descricao: x_descricao,
          data_1: x_data_1,
          data_2: x_data_2
        })
      }

      /* --------------------- SEGUNDO TRIMESTRE, ANO ATUAL --------------------- */
      x_data_1 = new Date(x_data_atual.getFullYear(), 3, 1);   /* 01/04/2019 */
      x_data_2 = new Date(x_data_atual.getFullYear(), 5, 30);  /* 30/06/2019 */
      x_descricao = '2º trim/' + x_data_1.getFullYear();

      /* Se o segundo trimestre já fechou no ano atual */
      if (x_data_atual > x_data_2) {
        this.periodos.push({
          indice: 6,
          descricao: x_descricao,
          data_1: x_data_1,
          data_2: x_data_2
        })
      }

      /* --------------------- TERCEIRO TRIMESTRE, ANO ATUAL --------------------- */
      x_data_1 = new Date(x_data_atual.getFullYear(), 6, 1);   /* 01/07/2019 */
      x_data_2 = new Date(x_data_atual.getFullYear(), 8, 30);  /* 30/09/2019 */
      x_descricao = '3º trim/' + x_data_1.getFullYear()

      /* Se o terceiro trimestre já fechou no ano atual */
      if (x_data_atual > x_data_2) {
        this.periodos.push({
          indice: 7,
          descricao: x_descricao,
          data_1: x_data_1,
          data_2: x_data_2
        })
      }
    },
    
    async criarGrafico(
      container_grafico,
      elemento_canvas_grafico,
      titulo_grafico,
      periodos_grafico,
      dados_grafico,
      cor_ativo_grafico,
      mostrar_titulo,
      casas_decimais
    ) {
    
      let cor_borda_grafico = '#9c1d1c';
      let cor_grafico = '#9c1d1c40';

      if (cor_ativo_grafico == 'S') {
        cor_grafico = '#0f806080';
        cor_borda_grafico = '#0f8060';
      }

      var ctx = await document.getElementById(`${elemento_canvas_grafico}`).getContext('2d');
    
      let myChart =  new Chart(ctx, {
          type: 'bar',
          data: {
            labels: periodos_grafico,
            datasets: [
              {
                borderColor: cor_borda_grafico,
                backgroundColor: cor_grafico,
                borderWidth: 2,
                pointBorderColor: '#d82456',
                data: dados_grafico,
                fontSize: 12,
                
              }
            ]
          },
          
          options: {
            responsive: false,
            legend: {display: false},
            title: {
              display: (mostrar_titulo == 'S'),  /* Tirei essa parada, se precisar, volta */
              text: titulo_grafico,
              fontSize: 10
            },
          
            showAllTooltips: true, // call plugin we created
            responsive: true,
            cutoutPercentage: 60,
            animation: {
              animateScale: true,
              animateRotate: true
            },
            scales: {
                xAxes: [{
                  ticks: {
                    fontSize: 12
                  }
                }],
                yAxes: [{
                  ticks: {
                    fontSize: 12
                  }
                }]
            },
            tooltips: {
              enabled: false,
              bodyFontSize: 10,
              backgroundColor: cor_borda_grafico,
              callbacks: {
                label: function(tooltipItem, data) {
                  var label = nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], casas_decimais);
                  return label;
                }
              }
            }
          }
        }
      )
    
    },
    
    ajustarTodasOpcoes(marcar) {
      for (let i in this.opcoes) {
        this.opcoes[i].marcado = marcar;
      }
      this.atualizarBotoesMarcacao();
    },

    atualizarBotoesMarcacao() {
      this.todas_opcoes_marcadas = true;
      for(let i in this.opcoes) {
        this.todas_opcoes_marcadas = this.opcoes[i].marcado;
        if (!this.todas_opcoes_marcadas) {
          break;
        }
      }
    },

    stringToDate(dataStr) {
      let apenas_data = dataStr.substring(0, 10);
      let partes = apenas_data.split("-");
      let retorno = new Date(partes[0], partes[1] - 1, partes[2]);
      return retorno;
    },

    dateToStringBR(data) {
      if (!data) {
        return '';
      }

      let dia = data.getDate().toString().padStart(2, "0");
      let mes = (data.getMonth() + 1).toString().padStart(2, "0");
      let ano = data.getFullYear();
      return dia + "/" + mes + "/" + ano;
    },

    apenasNumeros(texto) {
      let retorno = ''
      for (let i = 0; i < texto.length; i++) {
        if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(texto[i]) > -1) {
          retorno += texto[i];
        }
      }

      return retorno;
    },

    removerPeriodo(indice) {
      for (let i = 0; i < this.periodos.length; i++) {
        if (this.periodos[i].indice == indice) {
          this.periodos.splice(i, 1);
          break;
        }
      }
      this.ajustarIndicesPeriodos();
    },

    adicionarPeriodo() {
      if (!this.descricao_periodo_adicionar) {
        toastr.error('Informe a descrição do período!');
        $('#descricao_periodo').focus();
        return;
      }

      if (!this.data_inicial_adicionar) {
        toastr.error('Informe a data inicial!');
        $('#data_inicial_periodo').focus();
        return;
      }

      if (!this.data_final_adicionar) {
        toastr.error('Informe a data final!');
        $('#data_final_periodo').focus();
        return;
      }

      if (this.stringToDate(this.data_inicial_adicionar) > this.stringToDate(this.data_final_adicionar)) {
        toastr.error('A data inicial não pode ser posterior a data final!');
        $('#data_inicial_periodo').focus();
        return;
      }

      for (let i = 0; i < this.periodos.length; i++) {
        if (
            (
            (this.stringToDate(this.data_inicial_adicionar) >= this.periodos[i].data_1) &&
            (this.stringToDate(this.data_inicial_adicionar) <= this.periodos[i].data_2)
          ) || (
            (this.stringToDate(this.data_final_adicionar) >= this.periodos[i].data_1) &&
            (this.stringToDate(this.data_final_adicionar) <= this.periodos[i].data_2)
          )
        ) {
          toastr.error('Conflito de datas. Verifique os períodos já adicionados!')
          $('#data_inicial_periodo').focus();
          return;
        }
      }

      this.periodos.push({
        indice: 0,
        descricao: this.descricao_periodo_adicionar,
        data_1: this.stringToDate(this.data_inicial_adicionar),
        data_2: this.stringToDate(this.data_final_adicionar)
      })

      this.periodos.sort(
        function(a, b) {
          return a.data_1 > b.data_1 ? 1 : a.data_1 < b.data_1 ? -1 : 0;
        }
      );

      this.ajustarIndicesPeriodos();

      this.descricao_periodo_adicionar = undefined;
      this.data_inicial_adicionar = undefined;
      this.data_final_adicionar = undefined;
    },

    ajustarIndicesPeriodos() {
      for (let i in this.periodos) {
        this.periodos[i].indice = i + 1;
      }
    },

    configuracoesMarcadas() {
      let opcoes_marcadas = []
      for (let i in this.opcoes) {
        if (this.opcoes[i]) {
          opcoes_marcadas.push(
            this.opcoes[i]
          );
        }
      }

      return opcoes_marcadas;
    },

    gravarRelatorio() {
      localStorage.setItem(
        "textos-visoes-financeiras",
        JSON.stringify(this.textos)
      );

      if (localStorage.getItem("textos-visoes-financeiras")) {
        toastr.info('Os textos foram gravados com sucesso.');
      }
    },

    gravarConfiguracoes() {
      let opcoes_gravar = this.configuracoesMarcadas();

      let configuracoes_visoes_financeiras = {
        opcoes: opcoes_gravar,
        periodos: this.periodos
      }

      localStorage.setItem(
        "configuracoes-visoes-financeiras",
        JSON.stringify(configuracoes_visoes_financeiras)
      );

      this.fecharConfiguracoes();
    },

    abrirPaginaConfiguracao(idPagina) {
      let i
      let tabcontent = document.getElementsByClassName('pagina');
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none';
      }

      let tablinks = document.getElementsByClassName('tablinks');
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '');
      }

      document.getElementById(idPagina).style.display = 'block';
    },

    simNao(sn) {
      if (sn == 'S') {
        return 'Sim';
      }
      else {
        return 'Não';
      }
    },

    nPadraoPercentual(valor, casasDecimais) {
      if (nPadrao(valor, casasDecimais) == nPadrao(0, casasDecimais)) {
        return '';
      }
      else {
        return nPadrao(valor, casasDecimais) + '%';
      }
    },

    nPadrao: function(val, casas_decimais) {
      if (!val) {
        return "0";
      }

      let valor = Math.abs(val).toFixed(casas_decimais);
      let sinal = "";
      if (val < -0.001) {
        sinal = "-";
      }

      if (!valor) {
        return nPadrao(0, casas_decimais);
      }

      let numero;

      if (casas_decimais == 0) {
        let formato = { minimumFractionDigits: casas_decimais };
        numero = parseInt(valor);
        return numero.toLocaleString("pt-BR", formato);
      } else {
        if (
          valor.length - casas_decimais - 1 >= 0 &&
          valor.charAt(valor.length - casas_decimais - 1) == ","
        ) {
          numero = parseFloat(valor.replace(",", "."));
        } else {
          numero = parseFloat(valor);
        }

        numero = numero.toFixed(casas_decimais).split(".");
        numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");

        return sinal + numero.join(",");
      }
    },
    
    imprimir(){
      var conteudo = document.getElementById('visao-financeira').innerHTML;
      window.print(conteudo);
      window.close();
    }
  },
  created() {
    this.configurarApiGraficos();


    if (localStorage.getItem("configuracoes-visoes-financeiras")) {
      let configuracoes_visoes_financeiras = JSON.parse(localStorage.getItem("configuracoes-visoes-financeiras"))
      this.opcoes = [];
      this.opcoes = JSON.parse(JSON.stringify(configuracoes_visoes_financeiras.opcoes));
      let periodos_str = JSON.parse(JSON.stringify(configuracoes_visoes_financeiras.periodos));
      let contador = 0;
      
      for(let k in this.opcoes){
        if(this.opcoes[k].marcado){
          contador++;
        }
      }
      
      if(contador == this.opcoes.length){
        this.todas_opcoes_marcadas = true;
      }else{
        this.todas_opcoes_marcadas = false;
      }

      this.periodos = []
      for (let i in periodos_str) {
        this.periodos.push({
          indice: i + 1,
          descricao: periodos_str[i].descricao,
          data_1: this.stringToDate(periodos_str[i].data_1),
          data_2: this.stringToDate(periodos_str[i].data_2)
        })
      }

    }
    else {
      this.ajustarPeriodosPadroes();
    }

    if (localStorage.getItem("textos-visoes-financeiras")) {
      Object.assign(this.textos, JSON.parse(localStorage.getItem("textos-visoes-financeiras")));
    }
  }
}

function nPadrao(val, casas_decimais) {
  if (!val) {
    return "0";
  }

  let valor = Math.abs(val).toFixed(casas_decimais);
  let sinal = "";
  if (val < -0.001) {
    sinal = "-";
  }

  if (!valor) {
    return nPadrao(0, casas_decimais);
  }

  let numero;

  if (casas_decimais == 0) {
    let formato = { minimumFractionDigits: casas_decimais };
    numero = parseInt(valor);
    return numero.toLocaleString("pt-BR", formato);
  } else {
    if (
      valor.length - casas_decimais - 1 >= 0 &&
      valor.charAt(valor.length - casas_decimais - 1) == ","
    ) {
      numero = parseFloat(valor.replace(",", "."));
    } else {
      numero = parseFloat(valor);
    }

    numero = numero.toFixed(casas_decimais).split(".");
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");
    return sinal + numero.join(",");
  }
}


</script>

<style scoped>
  .listaOpcoes {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  h4 {
    color: #ffffff;
    background-color: #9c1d1c;
    border: 1px solid #000000;
    padding: 2px 2px 2px 10px;
    border-radius: 5px;
    text-align: center;
    font-weight: bold;
    margin-top: 60px;
  }

  h5 {
    color: #ffffff;
    background-image: linear-gradient(to right, #363434, #5c5757);
    border: 1px solid #000000;
    padding: 2px 2px 2px 10px;
    border-radius: 5px;
    font-weight: bold;
    margin-top: 60px;
  }

  h6 {
    color: #000000;
    background-image: linear-gradient(to right, #dddddd, #dbdbdb);
    border: 1px solid #999999;
    padding: 2px 2px 2px 10px;
    border-radius: 5px;
    text-align: left;
    margin-top: 30px;
    font-weight: bold;
  }

  .periodo {
    border: 1px solid #666666;
    padding: 0 5px 5px 5px;
    border-radius: 10px;
    margin: 2px;
    text-align: center;
  }

  .botao-fechar {
    padding-right: 3px;
    cursor: pointer;
  }

  .controlePaginas {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
  }

  /* Style the buttons that are used to open the tab content */
  .controlePaginas button {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
  }

  /* Change background color of buttons on hover */
  .controlePaginas button:hover {
    background-color: #ddd;
  }

  /* Create an active/current tablink class */
  .controlePaginas button.active {
    background-color: #ccc;
  }

  /* Style the tab content */
  .pagina {
    display: none;
    padding: 6px 0 0 0;
    border: 1px solid #ccc;
    border-top: none;
  }

  .tabela-resultado {
    border: 1px solid #999999;
    border-collapse: collapse;
    width: 100%;
    text-align: right;
  }

  .tabela-resultado-menor {
    border: 1px solid #999999;
    border-collapse: collapse;
    width: 100%;
    max-width: 700px;
    text-align: right;
    margin: auto;
  }

  .borda-pontilhada-base {
    border-bottom: 1px dotted #666666;
  }

  .cor-enfase {
    background-color: #90ee90;
  }

  .cor-enfase-2 {
    background-color: #e0ffff;
  }
  /*css para impressão*/
  p{
    visibility: hidden!important;
    display: none;
  }
  .apresentacao{
    visibility: hidden!important;
    display: none;
  }
  
  @media print {
    #visao-financeira * {
      visibility: hidden;
    }
    #visao-financeira, #visao-financeira * {
      visibility: visible;
    }
    #visao-financeira {
      position: fixed;
      left: 0;
      top: 0;
    }
    p{
      visibility: visible!important;
      display: block!important;
    }
    .apresentacao{
      visibility: visible!important;
      display: block!important;
    }
    .impressao{
      visibility: hidden!important;
      display: none;
    }
    textarea{
      visibility: hidden!important;
      display: none;
    }
    h4{
      color: black!important;
    }
    h5{
      color: black!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VisoesFinanceiras.vue